
/* ==========================================================
   HUMBOFIL 3D
   CATALOGO Y COTIZACIONES POR WHATSAPP
   Archivo: assets/humbofil-v2.js
   Version: 3.0
   ========================================================== */

(function () {
  'use strict';

  /* ========================================================
     1. EVITAR INICIALIZACION DUPLICADA
     ======================================================== */

  if (window.__humbofilCatalogInitialized) {
    return;
  }

  window.__humbofilCatalogInitialized = true;

  /* ========================================================
     2. UTILIDADES
     ======================================================== */

  function getQuantity(form) {
    const input = form.querySelector(
      'input[name="quantity"]'
    );

    if (!input) return null;

    const raw = input.value.trim();
    const value = Number(raw);

    if (
      raw === '' ||
      !Number.isInteger(value) ||
      value < 1 ||
      value > 999
    ) {
      return null;
    }

    return value;
  }

  function getSelectedVariant(form) {
    const select = form.querySelector(
      'select[name="variant"]'
    );

    if (!select) return null;

    return select.selectedOptions[0] || null;
  }

  function getPriceInCents(option) {
    if (!option) return null;

    const raw = option.dataset.priceCents;

    if (raw === undefined || raw === '') {
      return null;
    }

    const value = Number(raw);

    return Number.isFinite(value) && value >= 0
      ? value
      : null;
  }

  function getCurrency(form) {
    return form.dataset.currency || 'PEN';
  }

  function formatMoney(cents, currency) {
    const code = currency || 'PEN';

    try {
      return new Intl.NumberFormat('es-PE', {
        style: 'currency',
        currency: code
      }).format(cents / 100);
    } catch (error) {
      return new Intl.NumberFormat('es-PE', {
        style: 'currency',
        currency: 'PEN'
      }).format(cents / 100);
    }
  }

  /* ========================================================
     3. ACTUALIZAR SUBTOTAL
     ======================================================== */

  function updateSubtotal(form) {
    const subtotalElement = form.querySelector(
      '[data-hf-subtotal]'
    );

    if (!subtotalElement) return;

    const option = getSelectedVariant(form);
    const priceCents = getPriceInCents(option);
    const quantity = getQuantity(form);

    if (
      priceCents === null ||
      quantity === null
    ) {
      subtotalElement.textContent = '—';
      return;
    }

    const subtotalCents = priceCents * quantity;

    subtotalElement.textContent = formatMoney(
      subtotalCents,
      getCurrency(form)
    );
  }

  /* ========================================================
     4. ACTUALIZAR IMAGEN
     ======================================================== */

  function updateProductImage(card, option, form) {
    const image = card.querySelector(
      'img.hf-product-img'
    );

    if (!image || !option) return;

    const imageUrl = option.dataset.image;

    if (!imageUrl) return;

    const sources = [
      [option.dataset.image300, 300],
      [option.dataset.image500, 500],
      [option.dataset.image, 750]
    ].filter(function (item) {
      return Boolean(item[0]);
    });

    image.removeAttribute('srcset');

    image.src = imageUrl;

    image.alt =
      option.dataset.alt ||
      form.dataset.title ||
      'Producto HumboFil 3D';

    if (sources.length > 0) {
      image.srcset = sources
        .map(function (item) {
          return item[0] + ' ' + item[1] + 'w';
        })
        .join(', ');
    }

    image.sizes =
      '(max-width: 749px) 100vw, ' +
      '(max-width: 1100px) 50vw, 33vw';

    const width = Number(option.dataset.width);
    const height = Number(option.dataset.height);

    if (width > 0 && height > 0) {
      image.width = width;
      image.height = height;
    }
  }

  /* ========================================================
     5. ACTUALIZAR TARJETA DEL PRODUCTO
     ======================================================== */

  function updateProductCard(form) {
    const card = form.closest('.hf-product');

    if (!card) return;

    const option = getSelectedVariant(form);

    if (!option) return;

    const priceElement = card.querySelector(
      '.hf-price'
    );

    const button = form.querySelector(
      'button.hf-btn[type="submit"]'
    );

    const priceCents = getPriceInCents(option);

    /* PRECIO */

    if (priceElement) {
      if (priceCents !== null) {
        priceElement.textContent = formatMoney(
          priceCents,
          getCurrency(form)
        );
      } else {
        priceElement.textContent =
          option.dataset.price || '';
      }
    }

    /* DISPONIBILIDAD */
    
/* Cotización individual disponible */
if (button) {
  button.disabled = false;
  button.textContent = 'Cotizar por WhatsApp ↗';
}

    /* IMAGEN */

    updateProductImage(card, option, form);

    /* SUBTOTAL */

    updateSubtotal(form);
  }

  /* ========================================================
     6. INICIALIZAR CATALOGO
     ======================================================== */

  function initializeCatalog(root) {
    const container = root || document;

    const forms = container.querySelectorAll(
      '.hf-product form[data-hf-quote]'
    );

    forms.forEach(function (form) {
      updateProductCard(form);
    });
  }

  /* ========================================================
     7. CAMBIO DE VARIANTES
     ======================================================== */

  document.addEventListener('change', function (event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const select = target.closest(
      '.hf-product select[name="variant"]'
    );

    if (select) {
      const form = select.closest(
        'form[data-hf-quote]'
      );

      if (form) {
        updateProductCard(form);
      }

      return;
    }

    const quantityInput = target.closest(
      'form[data-hf-quote] input[name="quantity"]'
    );

    if (quantityInput) {
      const form = quantityInput.closest(
        'form[data-hf-quote]'
      );

      if (form) {
        updateSubtotal(form);
      }
    }
  });

  /* ========================================================
     8. ACTUALIZAR CANTIDAD EN TIEMPO REAL
     ======================================================== */

  document.addEventListener('input', function (event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const quantityInput = target.closest(
      'form[data-hf-quote] input[name="quantity"]'
    );

    if (!quantityInput) return;

    const form = quantityInput.closest(
      'form[data-hf-quote]'
    );

    if (!form) return;

    updateSubtotal(form);
  });

  /* ========================================================
     9. VALIDAR FORMULARIO
     ======================================================== */

  function validateForm(form) {
    const phone = (
      form.dataset.phone || ''
    ).replace(/\D/g, '');

    if (
      !/^51\d{9}$/.test(phone) ||
      phone === '51999999999'
    ) {
      alert(
        'Configura tu número de WhatsApp real ' +
        'en la sección HF · Catálogo temático.'
      );

      return null;
    }

    const option = getSelectedVariant(form);

    if (!option) {
      alert('Selecciona una presentación.');
      return null;
    }

    

    const quantity = getQuantity(form);

    if (quantity === null) {
      alert(
        'Ingresa una cantidad válida entre 1 y 999.'
      );

      return null;
    }

    return {
      phone: phone,
      option: option,
      quantity: quantity,
      priceCents: getPriceInCents(option)
    };
  }

  /* ========================================================
     10. CONSTRUIR MENSAJE DE WHATSAPP
     ======================================================== */

  function buildWhatsAppMessage(form, data) {
    const title =
      form.dataset.title ||
      'Producto HumboFil 3D';

    const productUrl =
      form.dataset.url ||
      window.location.href;

    const currency = getCurrency(form);

    const lines = [
      '¡Hola, HumboFil 3D! 👋',
      '',
      'Quisiera consultar por este producto:',
      '',
      '📦 Producto: ' + title
    ];

    /* VARIANTE */

    if (
      data.option.value &&
      data.option.value !== 'Default Title'
    ) {
      lines.push(
        '🎨 Presentación: ' + data.option.value
      );
    }

    /* CANTIDAD */

    lines.push(
      '🔢 Cantidad: ' + data.quantity
    );

    /* PRECIO Y SUBTOTAL */

    if (data.priceCents !== null) {
      lines.push(
        '💰 Precio unitario: ' +
        formatMoney(
          data.priceCents,
          currency
        )
      );

      lines.push(
        '💵 Subtotal estimado: ' +
        formatMoney(
          data.priceCents * data.quantity,
          currency
        )
      );
    }

    /* ENLACE DEL PRODUCTO */

    lines.push('');
    lines.push(
      '🔗 Producto: ' + productUrl
    );

    lines.push('');
    lines.push(
      '¿Me confirman disponibilidad y costo de entrega?'
    );

    return lines.join('\n');
  }

  /* ========================================================
     11. ENVIAR COTIZACION POR WHATSAPP
     ======================================================== */

  document.addEventListener('submit', function (event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const form = target.closest(
      'form[data-hf-quote]'
    );

    if (!form) return;

    event.preventDefault();

    const data = validateForm(form);

    if (!data) return;

    const message = buildWhatsAppMessage(
      form,
      data
    );

    const whatsappUrl =
      'https://wa.me/' +
      data.phone +
      '?text=' +
      encodeURIComponent(message);

    /* Abrir WhatsApp en una pestaña nueva */

    const popup = window.open(
      whatsappUrl,
      '_blank'
    );

    /* Alternativa si el navegador bloquea la pestaña */

    if (!popup) {
      window.location.assign(whatsappUrl);
    } else {
      try {
        popup.opener = null;
      } catch (error) {
        // Algunos navegadores restringen esta propiedad.
      }
    }
  });

  /* ========================================================
     12. CARGA INICIAL
     ======================================================== */

  function startCatalog() {
    initializeCatalog(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startCatalog,
      { once: true }
    );
  } else {
    startCatalog();
  }

  /* ========================================================
     13. EDITOR VISUAL DE SHOPIFY
     ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeCatalog(event.target);
    }
  );

})();
